import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=21f05683&scoped=true"
import script from "./menu-list.vue?vue&type=script&lang=js"
export * from "./menu-list.vue?vue&type=script&lang=js"
import style0 from "./menu-list.vue?vue&type=style&index=0&id=21f05683&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f05683",
  null
  
)

export default component.exports